import { Component, Input, OnInit } from '@angular/core';
import { IDashboardMidwifePayload } from 'src/app/models/dashboard.models';

@Component({
  selector: 'app-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss']
})
export class ProfileCardComponent implements OnInit {

  @Input() midwife: IDashboardMidwifePayload;

  constructor() { }

  ngOnInit(): void {
  }

}
